<template>
  <section class="flex min-w-0 flex-col gap-5">
    <div v-if="withHeading" class="flex flex-col gap-1">
      <h2 class="text-lg font-semibold">{{ t('admin.setup.contact.support.title') }}</h2>
      <p class="text-sm leading-normal text-muted-foreground">
        {{ t('admin.setup.contact.support.description') }}
      </p>
    </div>
    <div class="flex flex-col gap-2">
      <Label for="setup-support-email">{{ t('admin.setup.contact.supportEmail.label') }}</Label>
      <Input
        id="setup-support-email"
        v-model="form.SUPPORT_EMAIL"
        type="email"
        autocomplete="email"
        data-test-id="setup-support-email-input"
      />
    </div>
    <div class="flex flex-col gap-2">
      <Label for="setup-support-phone">{{ t('admin.setup.contact.supportPhone.label') }}</Label>
      <Input id="setup-support-phone" v-model="form.SUPPORT_PHONE" type="tel" autocomplete="tel" />
    </div>
    <slot />
  </section>
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { usePlatformSetup } from '@/features/admin/platform-setup/hooks/use-platform-setup.hook'
import { useI18n } from '@/lib/i18n'

withDefaults(defineProps<{ withHeading?: boolean }>(), { withHeading: true })

const { t } = useI18n()
const { form } = usePlatformSetup()
</script>
